import { createStore } from 'vuex'

export default createStore({
  state: {
    hamburgerVisible: false,
    hamburgerClick: 0,
    bgClass: '',
    themes: {
      dark: 'theme-dark',
      light: 'theme-light'
    },
    selectedTheme: '',
    switchIcon: '',
    hamburgerStatus: 'open'
  },
  getters: {
    hamburgerStatus: state => state.hamburgerStatus,
    bgClass: state => state.bgClass,
    selectedTheme: state => state.selectedTheme,
    switchIcon: state => state.switchIcon,
    hamburgerVisible: state => state.hamburgerVisible,
    hamburgerClick: state => state.hamburgerClick
  },
  mutations: {
    SET_VISIBILITY (state, payload) {
      state.hamburgerVisible = payload
    },
    UPDATE_HAMBURGER_CLICK (state, payload) {
      state.hamburgerClick = payload
    },
    SET_HAMBURGER_STATUS (state, payload) {
      state.hamburgerStatus = payload
    },
    SET_THEME_NAME (state, payload) {
      state.selectedTheme = payload
    },
    SET_SWITCH_ICON (state, payload) {
      state.switchIcon = payload
    },
    SET_THEME_HOME_BG (state, payload) {
      state.bgClass = payload
    }
  },
  actions: {
    switchTheme ({ state, commit }) {
      const themeSet = localStorage.getItem('theme')
      if (themeSet === state.themes.dark) {
        localStorage.setItem('theme', state.themes.light)
        localStorage.setItem('icon', 'fas fa-moon')
        localStorage.setItem('bgImage', '')
      } else {
        localStorage.setItem('theme', state.themes.dark)
        localStorage.setItem('icon', 'fas fa-sun')
        localStorage.setItem('bgImage', 'bgImage')
      }
      const selectedTheme = localStorage.getItem('theme')
      commit('SET_THEME_NAME', selectedTheme)
      const switchIcon = localStorage.getItem('icon')
      commit('SET_SWITCH_ICON', switchIcon)
      const bgClass = localStorage.getItem('bgImage')
      commit('SET_THEME_HOME_BG', bgClass)
    },
    TrackDOMClick ({ state, commit }) {
      if (state.hamburgerClick === 1) {
        commit('UPDATE_HAMBURGER_CLICK', 2)
      } else {
        commit('SET_VISIBILITY', false)
        commit('UPDATE_HAMBURGER_CLICK', 0)
        commit('SET_HAMBURGER_STATUS', 'open')
      }
    },
    trackHamburgerClick ({ state, commit }) {
      state.hamburgerVisible ? commit('SET_VISIBILITY', false) : commit('SET_VISIBILITY', true)
      if (state.hamburgerClick === 0) {
        commit('UPDATE_HAMBURGER_CLICK', 1)
        commit('SET_HAMBURGER_STATUS', 'close')
      } else if (state.hamburgerClick === 1) {
        commit('UPDATE_HAMBURGER_CLICK', 2)
        commit('SET_HAMBURGER_STATUS', 'open')
      }
    },
    setTheme ({ state, commit }) {
      /* check if the browser supports matchMedia and then it will try to match the prefers-color-scheme: dark string.
      If it matches then dark mode is active */
      let themeName = ''
      let themeSwitchIcon = ''
      let homeBgImage = ''
      if (localStorage.getItem('theme') && localStorage.getItem('theme') !== null) {
        themeName = localStorage.getItem('theme')
        themeSwitchIcon = localStorage.getItem('icon')
        homeBgImage = localStorage.getItem('bgImage')
      } else {
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
          themeName = 'theme-dark'
          themeSwitchIcon = 'fas fa-sun'
          homeBgImage = 'bgImage'
        } else {
          themeName = 'theme-light'
          themeSwitchIcon = 'fas fa-moon'
          homeBgImage = ''
        }
        localStorage.setItem('theme', themeName)
        localStorage.setItem('icon', themeSwitchIcon)
        localStorage.setItem('bgImage', homeBgImage)
      }
      commit('SET_THEME_NAME', themeName)
      commit('SET_THEME_HOME_BG', homeBgImage)
      commit('SET_SWITCH_ICON', themeSwitchIcon)
    }
  },
  modules: {
  }
})
